import { BrowserRouter } from 'react-router-dom';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { enUS } from "date-fns/locale";

import HubRoutes from "./routes";

import AuthProvider from './context/authContext';
import ToastProvider from "./context/toastContext";
import HubToast from './components/toast';
import LoaderProvider from './context/loaderContext';
import HubLoader from './components/loader';
import FooterProvider from './context/footerContext';
import NewVersionProvider from "./context/newVersionContext";
import NewVersionModal from './components/modals/newVersionModal';
registerLocale('enUS', enUS)
setDefaultLocale("enUS")



function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <LoaderProvider>
          <FooterProvider>
            <NewVersionProvider>
              <>
                <BrowserRouter>
                  <HubRoutes />
                </BrowserRouter>

                <HubToast />
                <HubLoader />
                <NewVersionModal />
              </>
            </NewVersionProvider>
          </FooterProvider>
        </LoaderProvider>
      </ToastProvider>
    </AuthProvider>
  );
};

export default App;
